export enum CacheStatusEnum {
  HIT = 'HIT',
  MISS = 'MISS',
}
